<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <frg-form-input class="free-entry" label="Saisie libre" id="freeEntry" type="checkbox"
                    isCheckLabelAlign="true" [formGroup]="formGroup" [control]="formGroup.get('freeEntry')">
                </frg-form-input>
                <div class="infos-units">
                    <div class="inline">
                        <frg-form-input label="Nom du produit" id="nom" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('nom')">
                        </frg-form-input>
                        <frg-form-input
                            *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false"
                            class="motif" label="Motif" id="motif" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('motif')">
                        </frg-form-input>
                    </div>
                    <div class="inline"
                        *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <frg-form-input label="Matin" id="matin" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('matin')" (modelChanged)="posologie()">
                        </frg-form-input>
                        <frg-form-input label="À 10h" id="dix" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('dix')" (modelChanged)="posologie()">
                        </frg-form-input>
                    </div>
                    <div class="inline"
                        *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <frg-form-input label="Midi" id="midi" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('midi')" (modelChanged)="posologie()">
                        </frg-form-input>
                        <frg-form-input label="À 16h" id="seize" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('seize')" (modelChanged)="posologie()">
                        </frg-form-input>
                    </div>
                    <div class="inline"
                        *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <frg-form-input label="Soir" id="soir" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('soir')" (modelChanged)="posologie()">
                        </frg-form-input>
                        <frg-form-input label="Au coucher" id="coucher" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('coucher')" (modelChanged)="posologie()">
                        </frg-form-input>
                    </div>
                    <div *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <frg-form-input label="La nuit" id="nuit" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('nuit')" (modelChanged)="posologie()">
                        </frg-form-input>
                    </div>
                    <div class="inline"
                        *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <frg-form-input label="Nombre de prises" id="nbrJours" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('nbrJours')" (modelChanged)="posologie()">
                        </frg-form-input>
                        <frg-form-input label="Rythme des prises" id="rythmePrises" type="ngSelect"
                            [formGroup]="formGroup" [control]="formGroup.get('rythmePrises')"
                            [selectValue]="listRythmePrise" [isClearableSelect]="true" (modelChanged)="posologie()"
                            isParentModal="true">
                        </frg-form-input>
                    </div>
                    <div class="inline"
                        *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <frg-form-input label="Nombre de boîtes" id="nbrBoites" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('nbrBoites')" (modelChanged)="posologie()">
                        </frg-form-input>
                        <frg-form-input label="Unité de prise" id="uniteBoites" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('uniteBoites')" (modelChanged)="posologie()">
                        </frg-form-input>
                    </div>
                    <div class="posologie-perso"
                        *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value === false">
                        <h3>Posologie</h3>
                        <p>{{ posologieForm }}</p>
                    </div>
                </div>
                <div *ngIf="formGroup.controls['freeEntry'] && formGroup.controls['freeEntry'].value">
                    <frg-form-input label="Posologie" id="freePosologie" type="textarea" [formGroup]="formGroup"
                        [control]="formGroup.get('freePosologie')">
                    </frg-form-input>
                </div>
                <div class="button-wrapper">
                    <frg-button (activated)="closeAddProductModal()" [backgroundColor]="'var(--darkest-primary)'">
                        Annuler
                    </frg-button>
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">
                        Ajouter</frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>